export default __webpack_public_path__ + "static/media/Punto_04_Finocchietti_ITA_Def.9792abd3.aac";